import React from 'react';
import 'antd/dist/antd.css';
import './App.css';
import Cell from './components/Cell'
import Tile from './components/Tile'
import SearchTile from './components/SearchTile'
import { Layout } from 'antd';

/* global ClipboardItem */

const { Footer, Content } = Layout;
const DEFAULT_BACKGROUND_URL = "https://wallpaper.kikkaai.com/all.php";


class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: props.width || -1,
            height: props.height || -1,
            index: new Date().getMilliseconds(),
            isEdit: false,
            config: null,
            tiles: [],
            copyStatus: 'Copy',
            copyStatusColor: 'white' // 新增：状态颜色
        };

        let mode = this.getQueryString("mode");
        mode = mode? mode: "www";

        fetch("data/" + mode + ".json")
        .then((res) => {
            return res.json();
        })
        .then((json_data) => {
            this.initConfig(json_data);
            this.makeTiles(json_data);
        })
        .catch((e) => {
            fetch("data/www.json")
            .then((res) => {
                return res.json();
            })
            .then((json_data) => {
                console.log(json_data);
                this.initConfig(json_data);
                this.makeTiles(json_data);
            })
            .catch((e) => {
                console.log(e.message);
            });
        });
    }

    onEdit = (checked, event) => {
        this.setState({
            isEdit: checked
        })
    };

    getQueryString(name) { 
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
        var r = window.location.search.substr(1).match(reg); 
        if (r != null) return unescape(r[2]); 
        return null; 
    } 

    initConfig (json_data) {
        let config = json_data["config"];
        let all = config.hasOwnProperty("all")? config["all"]: false;
        this.setState({
            config: {
                "all": all,
                "show_ICP": config["show_ICP"],
                "background": config["background"],
                "border_width": config["border_width"],
                "border_height": config["border_height"],
                "cell_box_w": config["cell_box_w"],
                "cell_box_h": config["cell_box_h"],
                "cell_w": config["cell_w"],
                "cell_h": config["cell_h"],
                "cell_row": config["cell_row"],
                "cell_column": config["cell_column"],
                "cell_space_w": config["cell_space_w"],
                "cell_space_h": config["cell_space_h"]
            }
        });
    }

    makeTiles (json_data) {
        let cells = json_data["cells"];
        let tiles = [];
        // console.log(cells);
        for (let i=0; i < cells.length; i++) {
            if(cells[i].type==="tile") {
                tiles.push(
                    <Tile
                        key={cells[i].id}
                        isEdit={this.state.isEdit}

                        x={cells[i].x}
                        y={cells[i].y}
                        w={cells[i].w}
                        h={cells[i].h}
                        color={cells[i].bgcolor}
                        title={cells[i].title}
                        url={cells[i].url}
                        icon={cells[i].icon}
                    />);
            } else if (cells[i].type==="search") {
                tiles.push(
                    <SearchTile
                        key={cells[i].id}
                        x={cells[i].x}
                        y={cells[i].y}
                        w={cells[i].w}
                        h={cells[i].h}
                        engine={cells[i].engine}
                    />);
            }

        }
        this.setState({
            tiles: tiles
        });
    }

    createImage(options) {
        options = options || {};
        const img = document.createElement("img");
        if (options.src) {
            img.src = options.src;
        }
        return img;
    };

    async copyToClipboard(pngBlob) {
        // 检查 Clipboard API 是否可用
        if (!navigator.clipboard || typeof ClipboardItem === 'undefined') {
            console.error('Clipboard API is not supported in this browser');
            alert('您的浏览器不支持复制图片功能，请使用 Chrome、Edge 或 Firefox 等现代浏览器。');
            return false;
        }
        
        try {
            await navigator.clipboard.write([
                new ClipboardItem({
                    [pngBlob.type]: pngBlob
                })
            ]);
            console.log("Image copied");
            return true;
        } catch (error) {
            console.error("Failed to copy image:", error);
            return false;
        }
    };

    convertToPng(imgBlob) {
        return new Promise((resolve) => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const imageEl = this.createImage({ src: window.URL.createObjectURL(imgBlob) });
            imageEl.onload = (e) => {
                canvas.width = e.target.width;
                canvas.height = e.target.height;
                ctx.drawImage(e.target, 0, 0, e.target.width, e.target.height);
                canvas.toBlob(async (blob) => {
                    const success = await this.copyToClipboard(blob);
                    resolve(success);
                }, "image/png", 1);
            };
        });
    };

    // 获取重定向后的真实图片 URL
    async getRedirectedImageUrl(redirectUrl) {
        try {
            this.setState({ copyStatus: 'Copy', copyStatusColor: 'white' });
            
            // 使用 fetch 跟随重定向
            const response = await fetch(redirectUrl, {
                method: 'HEAD', // 使用 HEAD 请求避免下载整个图片
                redirect: 'follow'
            });
            
            // 最终 URL 就是重定向后的真实图片 URL
            const finalUrl = response.url;
            console.log("Redirected to:", finalUrl);
            return finalUrl;
            
        } catch (error) {
            console.error("Failed to get redirected URL:", error);
            // 如果 HEAD 请求失败，尝试使用 XMLHttpRequest
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', redirectUrl, true);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            resolve(xhr.responseURL);
                        } else {
                            reject(new Error('Failed to get redirected URL'));
                        }
                    }
                };
                xhr.send();
            });
        }
    }

    async copyImg(redirectUrl) {
        console.log("Copying image from redirect URL:", redirectUrl);
        try {
            const actualImageUrl = await this.getRedirectedImageUrl(redirectUrl); // 获取重定向后的真实图片 URL
            const imgResponse = await fetch(actualImageUrl); // 下载真实的图片
            
            if (!imgResponse.ok) {
                throw new Error(`HTTP error! status: ${imgResponse.status}`);
            }
            
            const imgBlob = await imgResponse.blob();
            const extension = actualImageUrl.split(".").pop().toLowerCase().split("?")[0];
            const supportedToBeConverted = ["jpeg", "jpg", "gif"];
            
            let success = false;
            
            if (supportedToBeConverted.includes(extension)) {
                success = await this.convertToPng(imgBlob);
            } else if (extension === "png") {
                success = await this.copyToClipboard(imgBlob);
            } else {
                console.error("Format unsupported:", extension);
                this.setState({ copyStatus: 'Fail', copyStatusColor: 'red' });
                setTimeout(() => {this.setState({ copyStatus: 'Copy', copyStatusColor: 'white' });}, 3000);
                alert('不支持的图片格式：' + extension);
                return;
            }

            if (success) {
                // 复制成功
                this.setState({ copyStatus: 'Success', copyStatusColor: '#52c41a' });
                setTimeout(() => {this.setState({ copyStatus: 'Copy', copyStatusColor: 'white' });}, 3000);
            } else {
                // 复制失败
                this.setState({ copyStatus: 'Fail', copyStatusColor: '#ff4d4f' });
                setTimeout(() => {this.setState({ copyStatus: 'Copy', copyStatusColor: 'white' });}, 3000);
                alert('复制失败，请重试');
            }
            
        } catch (error) {
            console.error("Failed to copy image:", error);
            this.setState({ copyStatus: 'Fail', copyStatusColor: '#ff4d4f' });
            setTimeout(() => {this.setState({ copyStatus: 'Copy', copyStatusColor: 'white' });}, 3000);
            alert('复制失败：' + error.message);
        }
    };


    render(){
        let config = this.state.config;
        if (!this.state.config)
        {
            return (<div />);
        }

        let background_url = config["background"];
        if (background_url === "")
        {
            background_url = DEFAULT_BACKGROUND_URL;
        }
        background_url +=  "?index=" + this.state.index;
        let redirect_url = background_url + "&redirect=true";
        let source_url = background_url + "&source=true";
        let background_image = "url(" + redirect_url +")";

        let cells = [];
        let box_w = config["cell_column"] * (config["cell_w"] + config["cell_space_w"]) - config["cell_space_w"];
        let box_h = config["cell_row"] * (config["cell_h"] + config["cell_space_h"]) - config["cell_space_h"];
        if (this.state.isEdit) {
            for (let j = 0; j < config["cell_row"]; j++) {
                for (let i = 0; i < config["cell_column"]; i++) {
                    cells.push(<Cell x={i} y={j}/>)
                }
            }
        }

        return (
            <Layout className="layout-box" style={{backgroundImage: background_image}}>
                <Content style={{minWidth: box_w, minHeight: box_h}}>
                    <div className="content" style={{minWidth: box_w, minHeight: box_h}}>
                        <div className="cells-box" style={{minWidth: box_w, minHeight: box_h}}>
                            {cells}
                            {this.state.tiles}
                        </div>
                    </div>
                </Content>
                <Footer style={{textAlign: "center", fontSize: 6}}>
                    by A.A
                    | <a href={redirect_url} target="_blank" rel="noopener noreferrer">Wallpaper</a>
                    &nbsp;
                    | <a href={source_url} target="_blank" rel="noopener noreferrer">Source</a>
                    &nbsp;
                    | <a 
                        id="btn" 
                        onClick={() => this.copyImg(redirect_url)}
                        style={{ 
                            color: this.state.copyStatusColor,
                            cursor: 'pointer',
                            transition: 'color 0.3s ease'
                        }}
                      >
                        {this.state.copyStatus}
                      </a>
                    &nbsp;
                    { (config["show_ICP"])?( <span > | <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">粤ICP备15099650号</a></span>):("")}
                    &nbsp;
                    | Copyright © 2019-now
                </Footer>
            </Layout>
        )
    };
}

export default App;